var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        height: "100%",
        "content-class": "contest-request-access-dialog"
      },
      model: {
        value: _vm.showDialog,
        callback: function($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog"
      }
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("Contests.Request.Dialog.Heading")))]),
      _vm._v(" "),
      _c("h2", { staticClass: "contest-name" }, [
        _vm._v(_vm._s(_vm.contestName))
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Contests.Request.Dialog.Multiple")))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("Contests.Request.Dialog.Remaining")) + " "),
        _c("span", { staticClass: "entries-left" }, [
          _vm._v(_vm._s(_vm.entriesLeft))
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Contests.Request.Dialog.Again")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-center buttons" },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn--cancel secondary-btn",
              on: {
                click: function($event) {
                  _vm.showDialog = false
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Contests.Alias.Page.Cancel")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "primary-btn btn--yes",
              attrs: {
                to: {
                  name: "contests/registration/termsandconditions",
                  params: { contestId: _vm.contestId }
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Contests.Request.Dialog.Yes")) +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c487f12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c487f12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestRequestAccessDialog.vue
// module id = null
// module chunks = 